<script>
    export let url;

    import { fetchData } from './data';
    import { L } from './l18n';
    import { birthDates, genders, media } from './static';
    import { specification, uiLang } from './store';
    import { onMount } from 'svelte';
    
    import Menu from './Menu.svelte';

    $specification = window.specification;
    $uiLang = !!document.documentElement.lang ? document.documentElement.lang : uiLang;

    let promise = fetchData(url);
    let error;
    let wrapped = () => promise().catch(e => error = e)

    onMount(async () => {
        await promise;
    })
    
    function compareEN(a, b) {
        if (a.en < b.en) return -1;
        if (a.en > b.en) return 1;
        return 0;
    }
</script>

<style>
    .filters {
        margin-bottom: 1.6rem;
    }
</style>

<div class=filters>
    <Menu name=gender 
        heading={L('en: Gender | ga: Inscne')}
        options={genders}
        current={$specification.gender}/>

    <Menu name=birthDate
        heading={L('en: Birth date | ga: Dáta breithe')}
        options={birthDates}
        current={$specification.birthDate}/>

    {#await promise}
        <p>{L('en: Getting genres | ga: Seánraí á lorg')}…</p>
    {:then data}
        <Menu name=genre
            heading={L('en: Genre | ga: Seánra')}
            options={$uiLang === 'ga' ? data.genres : data.genres.sort(compareEN)}
            current={$specification.genre}/>
    {/await}

    <Menu name=media
        heading={L('en: Media | ga: Meáin')}
        options={media}
        current={$specification.media}/>

    {#await promise}
        <p>{L('en: Getting photographers | ga: Grianghrafadóirí á lorg')}…</p>
    {:then data}
        <Menu name=photographer
            heading={L('en: Photographer | ga: Grianghrafadóir')}
            options={data.photographers}
            current={$specification.photographer}/>
    {/await}

    {#if error}
        <p>{L('en: Some data could not be found. Are you offline? | ga: Níorbh fhéidir roinnt sonraí a fháil. An bhfuil tú as líne?')}</p>
    {/if}
</div>